import {GetMapping, PostMapping, RequestMapping2Class, RequestParam, RequestPart} from "../http";
import LbIndexDto from "./model/index/LbIndexDto";
import BaseListProduct from "./model/BaseListProduct";
import JewelryGalleryDto from "./model/index/JewelryGalleryDto";
@RequestMapping2Class("/lbIndex")
class LbIndexController{
    @GetMapping("/index")
    index(@RequestParam("edmCouponCodes") edmCouponCodes:string,@RequestParam("isPreview") isPreview:number):Promise<LbIndexDto>{throw 1;}
    @GetMapping("/loadAbove3")
    loadAbove3():Promise<Map<number,BaseListProduct[]>>{throw 1;}
    @GetMapping("/getCategoryProducts")
    getCategoryProducts(@RequestParam("categoryId") categoryId:number,@RequestParam("key") key:string):Promise<BaseListProduct[]>{throw 1;}
    @GetMapping("/jewelryGallery")
    jewelryGallery(@RequestParam("isPreview") isPreview:number):Promise<JewelryGalleryDto>{throw 1;}
}
const lbIndexController = new LbIndexController();
export { lbIndexController };